import { Box, CircularProgress } from '@mui/material';
import { LOADING_STATUS_PROPS, LoadingStatusText } from '@repo/ui';

export function LoginSkeleton() {
  return (
    <Box
      {...LOADING_STATUS_PROPS}
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: '400px', mx: 'auto' }}
    >
      <LoadingStatusText />
      <Box sx={{ mb: 2 }}>
        <Box sx={{ height: 32, bgcolor: 'grey.200', borderRadius: 1, mb: 1 }} />
      </Box>

      {/* Email/DNI field skeleton */}
      <Box sx={{ height: 52, bgcolor: 'grey.200', borderRadius: 1 }} />

      {/* Password field skeleton */}
      <Box sx={{ height: 52, bgcolor: 'grey.200', borderRadius: 1 }} />

      {/* Submit button skeleton */}
      <Box
        sx={{
          height: 44,
          bgcolor: 'grey.300',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={20} aria-hidden="true" />
      </Box>

      {/* Extra buttons skeleton */}
      <Box sx={{ height: 44, bgcolor: 'grey.200', borderRadius: 1 }} />
    </Box>
  );
}
